/** Console warn wrapper */
const warn = (...args: any[]) => {
  console.warn("[Chat SDK]:", ...args);
};

export default warn;
